import Header from './components/Header';
import Hero from './components/Hero';
import BusinessArea from './components/BusinessArea';
import Portfolio from './components/Portfolio';
import News from './components/News';
import TrustedPartners from './components/TrustedPartners';
import Footer from './components/Footer';
import QuickMenu from '../../components/feature/QuickMenu';
import { useSEO, createOrganizationSchema } from '../../utils/seo';

export default function Home() {
  useSEO({
    title: 'KR STUDIO - 콘텐츠 제작 이러닝 솔루션',
    description: 'KR스튜디오는 콘텐츠 제작, 라이브 스트리밍, 스튜디오 컨설팅, AI 콘텐츠 제작 등 전문적인 이러닝 솔루션을 제공합니다. 3,100개 이상의 프로젝트 경험으로 최고의 교육 콘텐츠를 만들어드립니다.',
    keywords: '콘텐츠 제작, 이러닝, 라이브 스트리밍, 스튜디오 컨설팅, AI 콘텐츠, 교육 콘텐츠, KR스튜디오',
    canonical: '/',
    schema: createOrganizationSchema(),
  });

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <BusinessArea />
      <Portfolio />
      <News />
      <TrustedPartners />
      <Footer />
      <QuickMenu />
    </div>
  );
}
